import { Icon, IconProps } from "@chakra-ui/react";
import React from "react";

const Sort: React.FC<IconProps> = (props) => {
  return (
    <Icon viewBox="0 0 17 22" boxSize="22px" {...props}>
      <path
        d="M2.26563 9.5C1.14063 9.5 0.53125 8.14062 1.375 7.29688L7.5625 0.921875C7.79688 0.640625 8.17188 0.5 8.5 0.5C8.82812 0.5 9.15625 0.640625 9.39062 0.921875L15.5781 7.29687C16.4219 8.14062 15.8125 9.5 14.6875 9.5L2.26563 9.5ZM14.6875 12.5C15.8125 12.5 16.4219 13.9062 15.5781 14.75L9.39063 21.125C9.15625 21.4062 8.82813 21.5 8.5 21.5C8.125 21.5 7.79688 21.4062 7.5625 21.125L1.375 14.75C0.53125 13.9062 1.14063 12.5 2.26563 12.5L14.6875 12.5Z"
        fill="black"
        fillOpacity="0.7"
      />
    </Icon>
  );
};

export default Sort;
